import React from 'react';
import { CursosPageQuery_cursos_ofertas } from '../../graphql/queries/__generated__/CursosPageQuery';
import { Container, Label, Turma } from './styles';

interface Props {
  oferta: CursosPageQuery_cursos_ofertas;
  loading?: boolean;
}

const InfoOferta: React.FC<Props> = (props) => {
  return (
    <Container active={props.oferta.turmas.some((t) => t.ativa) && !props.loading}>
      <Label>
        {props.oferta.num_ano}/{props.oferta.num_semestre}
      </Label>
      {props.oferta.dsc_email_assistente && (
        <span style={{ fontSize: '0.8rem', color: '#666', display: 'block', marginBottom: '8px' }}>
          Assistente: {props.oferta.dsc_email_assistente}
        </span>
      )}
      {props.oferta.turmas.map((turma) => (
        <Turma key={turma.id_turma} active={turma.ativa && !props.loading}>
          {props.oferta.num_oferta}.{turma.num_turma}
        </Turma>
      ))}
    </Container>
  );
};

export { InfoOferta };
